import { EventTranslate } from './eventTranslate.model';

const eventTranslatePTBR: EventTranslate = {
  page: {
    title: 'Quadro de eventos',
  },
  card: {
    title: 'Evento',
    date: 'Data',
    time: 'Hora',
    edit: 'Editar',
    addTodo: 'Nova tarefa',
    duplicate: 'Duplicar',
    location: 'Localização',
    options: {
      edit: 'Editar',
      delete: 'Excluir evento',
      move: 'Mover para…',
    },
  },
  column: {
    dropHere: 'Solte aqui',
    dragHere: 'Arraste para cá',
    addColumn: 'Adicionar coluna',
    newColumnName: 'Nome da coluna',
    create: 'Criar',
    cancel: 'Cancelar',
    archive: 'Arquivar',
    archiveConfirmTitle: 'Arquivar coluna',
    archiveConfirmEmpty: 'Tem certeza que deseja arquivar esta coluna?',
    archiveConfirmWithEvents:
      'Esta coluna possui {{count}} evento(s). Ao arquivar, todos os eventos associados tambem serao arquivados. Deseja continuar?',
    archiveConfirmButton: 'Arquivar',
    archiveCancelButton: 'Cancelar',
    rename: 'Renomear',
    renamePlaceholder: 'Novo nome da coluna',
    renameSubmit: 'Salvar',
    renameError: 'Erro ao renomear coluna',
  },
  archivedModal: {
    title: 'Colunas arquivadas',
    openButton: 'Abrir colunas arquivadas',
    empty: 'Nenhuma coluna arquivada',
    restoreButton: 'Restaurar',
    archivedAt: 'Arquivado em',
    restoreSuccess: 'Coluna restaurada com sucesso',
    restoreError: 'Erro ao restaurar coluna',
  },
  moveModal: {
    title: 'Mover evento',
    description: 'Escolha a coluna de destino',
    currentLabel: 'Atual',
    empty: 'Nenhuma outra coluna disponível',
    success: 'Evento movido',
    error: 'Erro ao mover evento',
  },
  widget: {
    title: 'Próximos eventos',
    viewAll: 'Ver todos',
    empty: 'Sem eventos nos próximos 7 dias',
    addNew: 'Novo evento',
  },
  imageConsent: {
    field: 'Autorização de uso de imagem',
    recordOnlyHint:
      'Este campo é um registro para você consultar. Ele não bloqueia a galeria nem impede a publicação.',
    label: 'Uso de imagem',
    option: {
      NOT_ASKED: 'Não perguntei',
      GRANTED: 'Pode postar',
      DENIED: 'Não pode postar',
    },
    badge: {
      NOT_ASKED: 'Uso de imagem não perguntado',
      GRANTED: 'Pode postar',
      DENIED: 'Não pode postar',
    },
    notice: {
      deniedTitle: 'Não pode postar',
      deniedDescription:
        'A cliente não autorizou o uso das imagens deste ensaio. Não publique estas fotos em redes sociais, site ou portfólio.',
      grantedTitle: 'Uso de imagem autorizado para este ensaio',
      leadDeniedTitle: 'Este cliente negou uso de imagem em outro ensaio',
      leadDeniedDescription:
        'A autorização desta galeria ainda não foi registrada. Confirme com o cliente antes de publicar estas fotos.',
      notAskedTitle: 'Autorização de imagem não perguntada',
      notAskedDescription:
        'Registre no evento se a cliente autoriza o uso das imagens deste ensaio.',
      noEventTitle: 'Galeria sem ensaio vinculado',
      noEventDescription:
        'Vincule esta galeria a um evento para acompanhar a autorização de uso de imagem.',
    },
  },
};

export default eventTranslatePTBR;
